import React from 'react';
import { IconButton } from '../../../../components/IconButton';

interface PropTypes {
  icon: string;
  url: string;
  text: string;
  className?: string;
}

export function ActivityButton(props: PropTypes) {
  return (
    <IconButton
      buttonText={props.text}
      buttonClass={props.className}
      color='borderless'
      onClick={() => (window.location.href = props.url)}
      iconName={props.icon}
    />
  );
}
